import { VkAuthCallbackHandler } from "@/features/auth/VkAuth/VkAuthCallbackHandler";
import router from "@/router/router";
import { useUpdate } from "@/shared/hooks/useUpdate";
import { queryClient } from "@/shared/lib/queryClient";
import { UpdateWindow } from "@/widgets/update/UpdateWindow";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { RouterProvider } from "react-router-dom";

function UpdateProvider() {
  const { status, isVisible, hasUpdate, startUpdate, closeWindow } = useUpdate({
    autoCheck: true,
    checkInterval: 30 * 60 * 1000, // Проверка каждые 30 минут
  });

  const handleUpdate = () => {
    startUpdate();
  };

  // Показываем виджет только при наличии обновления или процессе загрузки/установки (ошибки не показываем)
  const shouldShowWindow = isVisible && (hasUpdate || status.status === "downloading" || status.status === "downloaded");

  return (
    <UpdateWindow
      status={status}
      onUpdate={handleUpdate}
      onClose={closeWindow}
      visible={shouldShowWindow}
    />
  );
}

function App() {

  return (
    <QueryClientProvider client={queryClient}>
      <VkAuthCallbackHandler />
      <RouterProvider router={router} />
      <ReactQueryDevtools initialIsOpen={false} />
      <UpdateProvider />
    </QueryClientProvider>
  );
}

export default App;
